import { Outlet, useLocation } from "react-router-dom";
import Footer from "../footer/Footer";
import GeneralNavbar from "../navbar/GeneralNavbar";
import NavbarDash from "../navbar/NavbarDash";

const GeneralLayout = () => {
  const { pathname } = useLocation();
  const hideNavbarAndFooterPaths = ["/page-not-found", "/404"];

  const renderNavbar = () => {
    if (
      pathname.includes("admin") ||
      pathname.includes("client") ||
      pathname.includes("applicant")
    ) {
      return <NavbarDash />;
    }
    return <GeneralNavbar />;
  };

  return (
    <div className="general-layout">
      {!hideNavbarAndFooterPaths.includes(pathname) && renderNavbar()}

      <main className="general-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default GeneralLayout;
